module.exports = __webpack_public_path__ + "static/media/icon_diversification.fdd8c3c3.svg";